import { useTranslation } from 'react-i18next';

import { typography } from '@adflow/frontend/ui-theme';

export function Empty() {
	const { t } = useTranslation('common');
	return <span css={typography.emptySmall}>{t('Empty')}</span>;
}
